import OnboardingContainer from '$src/components/OnboardingContainer';
import useLocationContext from '$src/hooks/useLocationContext';
import { redirectToOnboardingRingSolutionsProfessionalMonitoring } from '$src/utils/redirect';
import { handleBackToRingDashboard } from '$src/utils/handleBack';
import useStores from '$src/hooks/useStores';
import { CalloutCard } from '@amzn/ring-react-components/csr/components/CalloutCard';
import { MonitoringSettingsIcon, NotMonitorableIcon } from '@ring-icons';

import SOSImg from '$src/assets/img/sos.png';

import './index.less';

function SOSTurnOn() {
  const locationId = useLocationContext();
  const {
    sessionStore: { isMobile },
  } = useStores();

  return (
    <OnboardingContainer
      headerTitle="Monitoring Setup"
      icon={MonitoringSettingsIcon}
      title="Let’s enable SOS for your Ring cameras."
      image={SOSImg}
      className="sos-turn-on"
      data-testid="sos-turn-on"
      primaryText="Continue"
      handleClose={() => handleBackToRingDashboard(isMobile)}
      hideBack
      primaryActionHandler={() => redirectToOnboardingRingSolutionsProfessionalMonitoring(locationId)}
      warningOnClose
    >
      <CalloutCard icon={<NotMonitorableIcon />} status="default" title={<b>SOS is turned off.</b>}>
        To use Virtual Security Guard, please turn on SOS.
      </CalloutCard>
      <div className="sos-turn-on__text-container--separator">
        <p className="sos-turn-on__paragraph-title">What does SOS do?</p>
        <p className="sos-turn-on__paragraph-text">
          SOS is a feature that allows you to request help from local authorities with a touch of a button inside the App.
        </p>
      </div>
    </OnboardingContainer>
  );
}
export default SOSTurnOn;
